//import Vue from 'vue';
import firebase from 'firebase';

var prodConfig = {
    apiKey: "AIzaSyCKHKjLo-MhRHdqWgemLirHmAwXBupqbZk",
    authDomain: "twinscupid-be9e4.firebaseapp.com",
    databaseURL: "https://twinscupid-be9e4.firebaseio.com",
    projectId: "twinscupid-be9e4",
    storageBucket: "twinscupid-be9e4.appspot.com",
    messagingSenderId: "741212981640",
};

var stgConfig = {
    apiKey: "AIzaSyDnst-mRR99pbbUnElLEoWjicbSMVZ6p7E",
    authDomain: "stg-twinscupid.firebaseapp.com",
    databaseURL: "https://stg-twinscupid-default-rtdb.firebaseio.com",
    projectId: "stg-twinscupid",
    storageBucket: "stg-twinscupid.appspot.com",
    messagingSenderId: "235537899636",
    appId: "1:235537899636:web:66dc78d22c99840d9f7121"
  };
var config = prodConfig;

export default {
    count: 0,
    app: null,

    myStore() {
        if (!this.app) {
            this.init();
        }
        return this.app.firestore();
    },
    myStorage() {
        if (!this.app) {
            this.init();
        }
        return this.app.storage();
    },

    init() {
        this.app = firebase.initializeApp(config);

        firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION)
            .then(function() {
                let email = 'abj1206@gmail.com';
                let password = 'yubiwa1206';
                return firebase.auth().signInWithEmailAndPassword(email, password);
            });
    },
    /*
    login() {
        firebase.auth().signInWithEmailAndPassword('mizuno@msys.co.jp', 'msys8888').
        catch(function(error) {
            var errorCode = error.code;
            var errorMessage = error.message;
            // [START_EXCLUDE]
            if (errorCode === 'auth/wrong-password') {
                alert('Wrong password.');
            } else {
                alert(errorMessage);
            }
            this.$console.log(error);
            return false;
        });
    },
    */
    logout() {
        firebase.auth().signOut();
    },

    async getUsers() {
        var Result = [];
        var dbRef = this.myStore().collection('users');
        await dbRef.get().then(function(snapshot) {
            if (snapshot.docs.length > 0) {
                snapshot.forEach(doc => {
                    Result.push(doc.data());
                });
            }
        });
        return Result;
    },

    /*-------------------------------------------------------------------
        guest or mguest からコールされる。
    -------------------------------------------------------------------*/
    async checkSerials(serial1, serial2) {
        var Result = [];
        var dbRef = this.myStore().collection('catalogs');
        var query = dbRef.where("serial1", "==", serial1).where("serial2", "==", serial2);
        await query.get().then(snapshot => {
            snapshot.forEach(d => {
                if (d.data().valid === 0) {
                    var item = {
                        key: d.id, // add doc.id
                        serial1: d.data().serial1,
                        serial2: d.data().serial2,
                        file1: d.data().file1,
                        file2: d.data().file2,
                        url1: d.data().url1,
                        url2: d.data().url2,
                        memo: d.data().memo,
                        createdt: d.data().createdt,
                        valid: d.data().valid
                    };
                    Result.push(item);
                }
            })
        });
        return Result;
    },
    /*-------------------------------------------------------------------
        get catalog data from firestore widh valid=0
    -------------------------------------------------------------------*/
    async getCatalogs() {
        var Result = [];
        var dbRef = this.myStore().collection('catalogs');
        await dbRef.get().then(function(snapshot) {
            if (snapshot.docs.length > 0) {
                snapshot.forEach(d => {
                    if (d.data().valid === 0) {
                        var docItem = {
                            key: d.id, // add doc.id
                            serial1: d.data().serial1,
                            serial2: d.data().serial2,
                            file1: d.data().file1,
                            file2: d.data().file2,
                            url1: d.data().url1,
                            url2: d.data().url2,
                            memo: d.data().memo,
                            createdt: d.data().createdt,
                            valid: d.data().valid
                        };
                        Result.push(docItem);
                    }
                });
            }
        });
        return Result;
    },


    /*----------------------------------------------------------
    *  add catalog item : return doc.key
    ------------------------------------------------------------*/
    addCatalog(item) {
        var Result = '';
        var newRef = this.myStore().collection('catalogs').doc();
        var newdt = {
            //key: newRef.id,
            serial1: item.serial1,
            serial2: item.serial2,
            file1: item.file1,
            file2: item.file2,
            url1: item.url1,
            url2: item.url2,
            memo: item.memo,
            createdt: item.createdt,
            valid: item.valid
        };
        let res = newRef.set(newdt); // return Promise
        res.then(function() {
                Result = newRef.id;
            })
            .catch(function(error) {
                this.console.error("Error adding Catalog : ", error);
            });
        return Result;
    },
    /*----------------------------------------------------------
    *  update catalog item : return true or false
    ------------------------------------------------------------*/
    async updateCatalog(item) {
        var Result = false;
        var updtData = {
            serial1: item.serial1,
            serial2: item.serial2,
            file1: item.file1,
            file2: item.file2,
            url1: item.url1,
            url2: item.url2,
            memo: item.memo,
            createdt: item.createdt,
            valid: item.valid
        };
        await this.myStore().collection("catalogs").doc(item.key).update(updtData)
            .then(function() {
                Result = true;
            })
            .catch(function(error) {
                this.console.error("Error Update Catalog : ", error);
            });
        return Result;
    },

    async deleteCatalog(item) {
        var Result = false;
        await this.myStore().collection("catalogs").doc(item.key).delete()
            .then(function() {
                Result = true;
            })
        return Result;
    },

    async deleteCatalogImage(filename) {
        var Result = false;
        let imgRef = this.myStorage.ref();
        await imgRef.child("catalogs/" + filename).delete()
            .then(function() {
                Result = true;
            });
        return Result;
    }
};